export class ReclassificationOptionEntity {
  public id!: string;
  public name!: string;
  public categoryName!: string;
}
